import { CompanyRole, UserRole } from '@/services/ws-permissions/src/main/resources/rest-api/types';
import { PermissionType } from '@/js/libs/generated/permissions/types';
import { CombinedRole } from './types';
const Roles = {
    ...CompanyRole,
    ...UserRole,
    ...PermissionType,
    ...CombinedRole,
};
export { Roles };
